module.exports = __webpack_public_path__ + "img/cow_cyrus.b9f06ea2.jpg";